export default "__VITE_ASSET__B6pE2buL__"